module.exports = __webpack_public_path__ + "img/surfer.d5551ae2.png";